class GltheaaCollectionFilters {
  static debounce(fn, wait = 400) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  static submit(event) {
    if (typeof FacetFiltersForm === 'undefined') return;

    const filterForm = document.getElementById('FacetFiltersFormMobile');
    const sortForm = document.getElementById('FacetSortDrawerForm');
    const params = new URLSearchParams();

    if (filterForm) {
      for (const [key, value] of new FormData(filterForm).entries()) {
        params.append(key, value);
      }
    }

    if (sortForm) {
      const sortBy = new FormData(sortForm).get('sort_by');
      if (sortBy) params.set('sort_by', sortBy);
    }

    FacetFiltersForm.renderPage(params.toString(), event);
  }

  static debouncedSubmit = GltheaaCollectionFilters.debounce((event) => {
    GltheaaCollectionFilters.submit(event);
  }, 400);
}

class GltheaaCollectionFiltersDrawer extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  connectedCallback() {
    this.drawer = this.closest('menu-drawer');
    this.addEventListener('click', this.onClick);
    this.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('change', this.onChange);
  }

  onClick(event) {
    const closeButton = event.target.closest('[data-gltheaa-filter-close]');
    if (closeButton) {
      this.drawer?.querySelector('summary')?.click();
      return;
    }

    const toggle = event.target.closest('.gltheaa-collection-filters__group-toggle');
    if (!toggle) return;

    const group = toggle.closest('.gltheaa-collection-filters__group');
    if (!group) return;

    const isExpanded = group.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

    const icon = toggle.querySelector('.gltheaa-collection-filters__group-icon');
    if (icon) {
      icon.classList.toggle('gltheaa-collection-filters__group-icon--minus', isExpanded);
      icon.classList.toggle('gltheaa-collection-filters__group-icon--plus', !isExpanded);
    }
  }

  onChange(event) {
    if (event.target.matches('.gltheaa-collection-filters__input')) {
      GltheaaCollectionFilters.submit(event);
      return;
    }

    if (event.target.closest('price-range')) {
      GltheaaCollectionFilters.debouncedSubmit(event);
    }
  }
}

if (!customElements.get('gltheaa-collection-filters-drawer')) {
  customElements.define('gltheaa-collection-filters-drawer', GltheaaCollectionFiltersDrawer);
}

window.GltheaaCollectionFilters = GltheaaCollectionFilters;

function gltheaaFacetRemoveFromHref(href) {
  if (!href || href.indexOf('?') === -1) return '';
  return href.slice(href.indexOf('?') + 1);
}

function gltheaaHandleFacetRemove(event) {
  const link = event.target.closest('[data-gltheaa-facet-remove]');
  if (!link || !link.closest('.facets-container--gltheaa')) return;
  if (event.defaultPrevented) return;

  if (typeof FacetFiltersForm === 'undefined') return;

  event.preventDefault();
  FacetFiltersForm.toggleActiveFacets();
  FacetFiltersForm.renderPage(gltheaaFacetRemoveFromHref(link.getAttribute('href')), event);
}

document.addEventListener('click', gltheaaHandleFacetRemove);
